import { render, staticRenderFns } from "./pi-delay-detail.vue?vue&type=template&id=add126f0"
import script from "./pi-delay-detail.vue?vue&type=script&lang=ts"
export * from "./pi-delay-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports